import { render, staticRenderFns } from "./demo-inputs.vue?vue&type=template&id=eb8af7e6&scoped=true&"
import script from "./demo-inputs.vue?vue&type=script&lang=js&"
export * from "./demo-inputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8af7e6",
  null
  
)

export default component.exports